import {AfterViewInit, Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {TorchFilesService} from '../../../../@backend/modules';
import {interval, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';


// 30 minutes
const REFRESH_AUTH = 30 * 600;

@Component({
  selector: 'app-files-auth',
  templateUrl: './files-auth.component.html',
  styleUrls: ['./files-auth.component.scss']
})
export class FilesAuthComponent implements AfterViewInit, OnDestroy {

  @ViewChild('authFrame') authFrame: ElementRef<HTMLIFrameElement>;

  imageURL: SafeResourceUrl;

  private _unsubscribeAll = new Subject();
  private _interval;

  constructor(private filesService: TorchFilesService, private sanitizer: DomSanitizer) {
    this.imageURL = sanitizer.bypassSecurityTrustResourceUrl(this.filesService.authImageURL);
  }

  ngAfterViewInit() {
    this._interval = interval(REFRESH_AUTH).pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(() => this.reloadAuthFrame());
  }

  ngOnDestroy() {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private reloadAuthFrame() {
    return this.authFrame.nativeElement.contentWindow.location.reload();
  }
}
